// routes/index.js - 무용연 라우트 모음
import { MuyeonRouter } from "routes/muyeonRouter/MuyeonRouter";

export const privateRouteDefs = [
  ...MuyeonRouter,
];
